import {useUsersRepository} from '@/dataSource/src/api/users/useRepository';
import {ErrorType} from '@/hooks/TrackingManager/utils';
import {
  IEventBaseDataSchema,
  IEventIdentifyDataDefinition,
  ITrackingService,
  TrackingEvent,
} from '@/services';
import {getTrackingService} from '@/services/tracking/getTrackingService';

import {trackEventLogic} from './trackingManager';

// Re-exported so existing imports (e.g. tests) that pull `getTrackingService`
// from this hook module keep working — the provider-selection logic itself
// now lives in `@/services/tracking/getTrackingService` so non-hook callers
// (like `reAuth.ts`) can reuse it without importing a hook file.
export {getTrackingService};

export const useTrackingManager = () => {
  const {
    trackEvent: trackEventService,
    reset: resetService,
    trackIdentifyEvents: trackIdentifyEventsService,
    trackNavigation,
  }: ITrackingService = getTrackingService();
  const {profile} = useUsersRepository();
  const trackEvent = (
    eventName: TrackingEvent,
    eventData: IEventBaseDataSchema,
    error?: ErrorType,
    extraData?: Object,
    trackPii: boolean = false,
  ) => {
    trackEventLogic({
      eventName,
      eventData,
      trackEventService,
      error,
      trackPii,
      showEmailAndPhone: false,
      familyId: profile?.familyId,
      extraData,
    });
  };

  const trackIdentifyEvents = (
    identity: string,
    eventData: IEventIdentifyDataDefinition,
  ) => {
    trackIdentifyEventsService(identity, {
      ...eventData,
      ...(profile?.familyId && {organization_id: profile?.familyId}),
    });
  };

  const resetAnalytics = () => {
    resetService();
  };

  return {
    trackNavigation,
    trackIdentifyEvents,
    trackEvent,
    resetAnalytics,
  };
};
